const qs = require('qs')

export const SCOPES = ['snsapi_base', 'snsapi_userinfo']

export class VueWechatAuthPlugin {
  constructor(scope = SCOPES[0]) {
    this.appid = null
    this.scope = scope
    this._code = null
    this._redirect_uri = null
  }

  static makeState() {
    return (
      Math.random()
        .toString(36)
        .substring(2, 15) +
      Math.random()
        .toString(36)
        .substring(2, 15)
    )
  }
  setAppId(appid) {
    this.appid = appid
  }
  returnFromWechat(redirect_uri) {
    const baseWithSearch = redirect_uri.split('#')[0]
    let parsedUrl = ''

    parsedUrl = qs.parse(baseWithSearch.split('?')[1])
    if (this.state === null) {
      throw new Error("You did't set state")
    }
    if (parsedUrl.state === this.state) {
      this.state = null
      this._code = parsedUrl.code
    } else {
      this.state = null
      throw new Error(`Wrong state: ${parsedUrl.state}`)
    }
  }
  auth() {
    window.location = this.authUrl
  }
  set last_auth_at(t) {
    localStorage.setItem('wechat_auth:last_auth_at', t)
  }
  get last_auth_at() {
    return Number(localStorage.getItem('wechat_auth:last_auth_at'))
  }
  set redirect_uri(redirect_uri) {
    this._redirect_uri = encodeURIComponent(redirect_uri)
  }
  get redirect_uri() {
    return this._redirect_uri
  }
  get state() {
    return localStorage.getItem('wechat_auth:state')
  }
  set state(state) {
    localStorage.setItem('wechat_auth:state', state)
  }
  get authUrl() {
    if (this.appid === null) {
      throw new Error('appid must not be null')
    }
    if (this.redirect_uri === null) {
      throw new Error('redirect uri must not be null')
    }
    this.state = VueWechatAuthPlugin.makeState()
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${this.redirect_uri}&response_type=code&scope=${this.scope}&state=${this.state}#wechat_redirect`
  }
  get code() {
    if (this._code === null) {
      return null
    }
    const code = this._code
    this._code = null
    // console.log('code: ' + code)
    return code
  }
}
